import React from 'react';
import {ImageBackground, View, Image, Platform} from 'react-native';

const LoginHeader = props => {
   const isLandscapeMode = props.isLandscapeMode;
   return (
      <ImageBackground
         source={require('../../assets/background.jpg')}
         imageStyle={{borderRadius: isLandscapeMode ? 8 : 0}}
         style={{width: '100%', height: '100%'}}>
         <View
            style={{
               flex: 1,
               alignItems: 'center',
               justifyContent: 'center',
               minHeight: 200,
            }}>
            <Image
               source={require('../../assets/my_logo_header.png')}
               style={{
                  width: !isLandscapeMode ? 80 : 160,
                  height: !isLandscapeMode ? 80 : 160,
                  resizeMode: 'contain',
               }}
            />
         </View>
      </ImageBackground>
   );
};

export default LoginHeader;
